import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 overflow-hidden flex-grow" }
const _hoisted_2 = { class: "flex space-x-2" }
const _hoisted_3 = {
  key: 0,
  class: "cursor-pointer text-trader-red text-sm font-bold",
  title: "die Bilder sind wahrscheinlich nicht gemountet weswegen einzelne funktionen nicht Funktionieren werden"
}
const _hoisted_4 = { class: "flex flex-shrink-0 flex-col gap-2 electron:px-2" }
const _hoisted_5 = { class: "flex gap-2" }
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = { class: "flex-grow flex gap-2 overflow-hidden electron:px-2" }
const _hoisted_8 = { class: "flex flex-col flex-grow overflow-hidden gap-2" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "flex flex-col flex-shrink-0 w-[300px] overflow-hidden gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-trader-red font-bold w-full text-center"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "flex h-full gap-1 w-full"
}
const _hoisted_15 = ["src", "onDragstart"]
const _hoisted_16 = {
  key: 3,
  class: "flex h-full gap-1 w-full"
}
const _hoisted_17 = ["src", "onDragstart"]
const _hoisted_18 = ["src", "onDragstart"]
const _hoisted_19 = ["src", "onDragstart"]
const _hoisted_20 = ["src", "onDragstart"]
const _hoisted_21 = ["src", "onDragstart"]
const _hoisted_22 = { class: "w-full flex flex-col" }
const _hoisted_23 = { class: "p-2" }
const _hoisted_24 = { class: "flex w-full border-b border-trader-light-gray gap-1 items-center" }
const _hoisted_25 = { class: "grid w-full grid-cols-5 gap-1" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex w-full border-b border-trader-light-gray p-2" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "flex w-full border-b border-trader-light-gray p-2" }
const _hoisted_30 = { class: "flex w-full border-b border-trader-light-gray p-2" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "flex w-full border-b border-trader-light-gray p-2" }
const _hoisted_33 = { class: "flex w-full border-b border-trader-light-gray p-2" }
const _hoisted_34 = { class: "break-words w-1/2" }
const _hoisted_35 = { class: "flex w-full border-b border-trader-light-gray p-2" }
const _hoisted_36 = { class: "break-words w-1/2" }
const _hoisted_37 = { class: "flex w-full border-b border-trader-light-gray p-2" }
const _hoisted_38 = { class: "break-words w-1/2" }
const _hoisted_39 = { class: "flex w-full p-2" }
const _hoisted_40 = { class: "break-words w-1/2" }
const _hoisted_41 = { class: "flex w-full gap-2 flex-shrink-0 h-[250px] electron:px-2 electron:pb-2" }
const _hoisted_42 = { class: "overflow-hidden gap-2 flex flex-col flex-grow" }
const _hoisted_43 = { class: "flex gap-2" }
const _hoisted_44 = { class: "overflow-hidden flex-grow" }

import {mutation, query} from "@/graphql";
import {onMounted, ref} from "vue";
import TRTable from "@/components/Base/TRTable.vue";
import TRTablePager from "@/components/Base/TRTablePager.vue";
import {electron} from "@/electron";
import TRButton from "@/components/Base/v2/TRButton.vue";
import TRInput from "@/components/Base/v2/TRInput.vue";
import TRSelect from "@/components/Base/v2/TRSelect.vue";
import TRContainer from "@/components/Base/v2/TRContainer.vue";
import TRToolbar from "@/components/Base/v2/TRToolbar.vue";
import TRListe from "@/components/Base/v2/TRListe.vue";
import Spinner from "@/components/Base/Spinner.vue";


//imgLocFileModDate imgLocMarkedForDeletion imgLocMainFileSize imgLocNewFilename
// Änderungsdatum Löschen Bildgröße  Bildname go2Trade

export default /*@__PURE__*/_defineComponent({
  __name: 'Asset',
  setup(__props) {

const header = [
  {title: "#", field: "isInFavorite", width: 50},
  {title: "Bildname auf dem Server", field: "imgLocOrgFilepath", width: null},
  {title: "Änderungsdatum", field: "imgLocFileModDate", width: 200},
  {title: "Löschen", field: "imgLocMarkedForDeletion", width: 80},
  {title: "Bildgröße", field: "imgLocMainFileSize", width: 80},
  {title: "Bildname go2Trade", field: "imgLocNewFilename", width: 200},
];

const selectOptions = [
  {value: 0, label: 'Im Namen oder in Artikelnummer'},
  {value: 1, label: 'Im Pfad'},
  {value: 2, label: 'Go2Pict ID'},
  {value: 3, label: 'Ist nicht im Namen oder Pfad'},
  {value: 4, label: 'In Artikelnummer'},
  {value: 5, label: 'In Einkaufsbereich'},
  {value: 6, label: 'In Warengruppe'},
  {value: 7, label: 'Im original Pfad'},
];
const selectedArticleNumber = ref("");
const articleNumbers = ref([]);
const purchaserCell = ref([]);
const searchPurchaser = ref("");
const searchType = ref("");
const myCheckbox = ref(null)
const addToArticleScheckBox = ref(null);
const searchWithNumber = ref(false);
let addToArticle = ref(false);
let showSpinner = ref(false);
let purchaserId = ref(0);
let imgLocGo2pictClass = ref(0);
const picturesData = ref({});
const pictureData = ref({});
const searchTerm = ref("");
const searchTerms = ref([]);
const tableData = ref([]);
const showFavorite = ref(false);
const numberOfPictures = ref(0);
const count = ref(1);
const selectSearchOption = ref(0);
let articleNumber = ref("");
const purchasers = ref("");
const importClass = ref([]);
const serverIsMounted = ref(true);
const pictureIsMounted = ref(true);

function addToArticleNumberToMainArticle() {
  addToArticle.value = !addToArticle.value;
  const checkbox = addToArticleScheckBox.value; // Zugriff auf die Checkbox
  if (checkbox) {
    checkbox.checked = !checkbox.checked; // Checkbox toggeln

  }
}

function searchWithOutArticleNumber(isChecked) {
  searchWithNumber.value = isChecked;
  loadData();
}

async function exportImages() {
  try {
    showSpinner.value = true;

    let exportImages = []

    picturesData.value.forEach(image => {
      exportImages.push({
        imgLocNewFilename: image.imgLocNewFilename,
        imgLocID: image.imgLocID,
        imgLocProductName: image.imgLocProductName,
      })
    })

    const [data, err] = await mutation.exportImages(exportImages, addToArticle.value);
    if (err) {
      console.error(err);
    }
  } catch (e) {
    console.error(e);
  } finally {
    showSpinner.value = false;
    await loadData();
  }

}

function toggleCheckbox() {
  const checkbox = myCheckbox.value; // Zugriff auf die Checkbox
  if (checkbox) {
    checkbox.checked = !checkbox.checked; // Checkbox toggeln
    searchWithOutArticleNumber(checkbox.checked); // Funktion mit aktuellem Zustand aufrufen
  }
}

async function updateImageClass() {

  const imgIds = [];
  const pictureIds = [];
  picturesData.value.forEach((image) => {
    imgIds.push(image.imgLocID);
    pictureIds.push(image.imgLocGo2pictIDPicture);
  });

  const [data, err] = await mutation.editImagesClass(imgIds, imgLocGo2pictClass.value, pictureIds);
  if (err) {
    console.error(err);
  }
  await loadData();
}


function getImgLocGo2pictClass(importClass) {
  imgLocGo2pictClass.value = importClass.id;
}

function searchForFood() {
  if (searchType.value === "food") {
    searchType.value = "";
  } else {
    searchType.value = "food";
  }

  loadData();
}


function searchForNonFood() {
  if (searchType.value === "nonFood") {
    searchType.value = "";
  } else {
    searchType.value = "nonFood";
  }
  loadData();
}

async function editImageFavorite(row) {
  let imgLocID = row.imgLocID;
  row.isInFavorite = !row.isInFavorite;
  let isInFavorite = !row?.isInFavorite;
  const [data, err] = await mutation.editImageFavorite(imgLocID, isInFavorite);
  if (err) {
    console.error(err);
  }
}

async function updatePurchaser() {

  const imgIds = [];
  const productIds = [];

  picturesData.value.forEach((image) => {
    imgIds.push(image.imgLocID);
    productIds.push(image.imgLocGo2pictIDProductPic);

  });

  const [data, err] = await mutation.editImagesPurchaser(imgIds, purchaserId.value, productIds);
  if (err) {
    console.error(err);
  }
  await loadData();


}

function getPurchaserId(purchaser) {
  purchaserId.value = purchaser.id;
}


function resetSearch() {
  searchPurchaser.value = "";


}


function formatCellValue(row, field, selected) {
  let value = row[field];

  let textColor = "";
  let fontWeight = "";

  // Neue Regel: Schriftgewicht basierend auf imgLocArticleNumber
  if (row.imgLocArticleNumber == null || row.imgLocArticleNumber === "") {
    fontWeight = "font-normal";
  } else {
    fontWeight = "font-bold";
  }

  // Neue Regel: Textfarbe basierend auf imgLocGo2pict
  if (row.imgLocGo2pict == "0") {
    textColor = "text-red-500";
  } else {
    // Wenn textColor noch nicht gesetzt ist, Standardfarbe verwenden
    textColor = "text-trader-text";

    if (selected) {
      textColor = "text-trader-highlight";
    }
  }

  // Zusätzliche Formatierungen für bestimmte Felder
  if (field === "imgLocMarkedForDeletion") {
    value = value.toLowerCase() === "yes" ? "Ja" : "Nein";
  } else if (field === "imgLocMainFileSize") {
    value = formatBytes(value);
  }

  // Kombiniere die Stile
  let style = [textColor, fontWeight].filter(Boolean).join(' ').trim();

  return '<span class="' + style + '">' + value + '</span>';
}


function showFavoritePictures() {
  showFavorite.value = !showFavorite.value;
  if (showFavorite.value) {
    tableData.value = tableData.value.filter((item) => item.isInFavorite);
  } else {
    loadData();
  }
}

async function getImportClass() {
  const [data, err] = await query.getImportClass();

  data?.forEach((item) => {
    importClass.value.push({value: item.pictureClass, id: item.idPictureClass});
  });
  if (err) {
    console.error(err);
  }

}

async function getPurchasers() {
  const [data, err] = await query.getPurchasers();
  purchasers.value = data;
  data.forEach((item) => {
    purchaserCell.value.push({value: item.name + " - " + item.teamIcon, id: item.id});
  });
  if (err) {
    console.error(err);
  }

}

function timestampToDate(timestamp) {
  const date = new Date(timestamp * 1000);
  const formattedDate = date.toLocaleDateString("de-DE"); // Formatiert für deutsches Datum
  return formattedDate;
}

function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB", "TB"];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  let size = 0;
  if (i == 0) {
    size = (bytes / Math.pow(k, i)).toFixed(0);
  } else {
    size = (bytes / Math.pow(k, i)).toFixed(2);
  }
  return `${size} ${units[i]}`;
}

async function loadData() {
  let data = await query.getAsset(searchTerm.value, count.value, selectSearchOption.value, searchType.value, searchWithNumber.value);
  try {
    // Wenn das erste Element ein Array ist, dann nimm es, ansonsten gib das leere Array zurück.
    if (Array.isArray(data[0])) {
      data = data[0]; // Nimm das erste Array
    } else {
      data = []; // Falls es nicht existiert, setze ein leeres Array
    }
    if (tableData.value !== data[0].image) {
      tableData.value = data[0].image;
    }
    numberOfPictures.value = Math.ceil(data[0].numberOfImages / 100);
  } catch (e) {
    console.error(e);
  }
}

const openInPhotoshop = () => {
  let picture = pictureData.value.imgLocOrgFilepath;
  electron.openFileInPhotoshop(picture);
};

const openAndHighlightFileInFinder = () => {
  let picture = pictureData.value.imgLocOrgFilepath;
  electron.openFileInFinder(picture);
};

const startImageDownload = (event, picture) => {
  event.preventDefault(); // Standardverhalten verhindern
  let filePath = picture.imgLocOrgFilepath;
  if (filePath) {
    // Debugging
    filePath = filePath.replace(/\*/g, "%2A");
    const extension = filePath.substring(filePath.lastIndexOf('.') + 1);
    if (window?.electronAPI) {
      window.electronAPI.downloadImage(filePath, picture.imgLocProductName + "." + extension);
    }
  }
}


const onDragStart = (event, picture) => {

  event.preventDefault(); // Standardverhalten verhindern

  // check if the picture is mounted
  electron.isMountAccessible(tableData.value[0].imgLocOrgFilepath).then((result) => {
    pictureIsMounted.value = result;
  });

  let filePath = picture.imgLocOrgFilepath;
  filePath = filePath.replace(/\*/g, "%2A");


  if (window?.electronAPI) {
    window?.electronAPI.startDrag(filePath); // Drag-Aktion starten
  }
}


function onSelectionChange(rows: TableRowType[]) {

  picturesData.value = rows;
  pictureData.value = picturesData.value[picturesData.value.length - 1];

  if (pictureData.value.imgLocArticleNumber) {
    articleNumbers.value = pictureData.value.imgLocArticleNumber
        .split(',')
        .map(item => item.trim())
        .filter(item => !isNaN(item) && item !== '')
        .map(Number);
  } else {
    articleNumbers.value = ["----------"];
  }

}

function onPageStep(page: number) {
  count.value = page;
  loadData()
}

function searchWithTerm(term) {
  searchType.value = "";
  searchTerm.value = term;
  // wenn term noch nicht in searchTerms  existiert, dann   searchTerms.value.push(searchTerm.value);
  if (!searchTerms.value.includes(searchTerm.value) && searchTerms.value && searchTerm.value !== "") {
    searchTerms.value.push(searchTerm.value);
  }
  loadData();
}


const openNewArticleWindow = async (articleNumber) => {

  selectedArticleNumber.value = articleNumber;
  const [size, sizeErr] = await electron.getWindowSize("main")
  const [pos, posErr] = await electron.getWindowPosition("main")

  electron.openNewWindow("articleWindow", "http://localhost:8101/article/" + articleNumber, {
    parent: "main",
    transparent: false,
    frame: true,
    titleBarStyle: 'default',
    x: pos.x + size.width,
    y: pos.y,
  }, {
    showCustomTitlebar: false,
  });
  electron.setWindowPosition("articleWindow", pos.x + size.width, pos.y);

};

const openArticleWindow = async () => {

  const [size, sizeErr] = await electron.getWindowSize("main")
  const [pos, posErr] = await electron.getWindowPosition("main")

  let arr = []

  picturesData.value.forEach((item) => {
    arr.push(item.imgLocArticleNumber);
  });
  const uniqueNumbers = [...new Set(arr.flatMap(item => item.split(',')))];
  const articleNumber = uniqueNumbers.join(',');


  electron.openNewWindow("articleWindow", "http://localhost:8101/article/" + articleNumber, {
    parent: "main",
    transparent: false,
    frame: true,
    titleBarStyle: 'default',
    x: pos.x + size.width,
    y: pos.y,
  }, {
    showCustomTitlebar: false,
  });
  electron.setWindowPosition("articleWindow", pos.x + size.width, pos.y);

};


onMounted(async () => {

  await loadData();
  await getImportClass();
  await getPurchasers();
  electron.isMountAccessible(tableData.value[0].imgLocOrgFilepath).then((result) => {
    serverIsMounted.value = result;
  });

});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TRToolbar, { class: "flex-shrink-0 flex items-center justify-between" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TRButton, {
            class: "min-w-[130px] p-1",
            text: "Favoriten anzeigen",
            "icon-position": 'left',
            icon: "fa-solid fa-star",
            onClick: showFavoritePictures
          }),
          _createVNode(TRButton, {
            class: "min-w-[130px]",
            text: "Bild im Finder anzeigen",
            "icon-position": 'left',
            icon: "fa-solid fa-images",
            onClick: openAndHighlightFileInFinder
          }),
          _createVNode(TRButton, {
            class: "min-w-[130px]",
            text: "Bild in Photoshop öffnen",
            "icon-position": 'left',
            icon: "fa-regular fa-images",
            onClick: openInPhotoshop
          }),
          _createVNode(TRButton, {
            class: "min-w-[130px]",
            text: "Bild runterladen",
            "icon-position": 'left',
            icon: "fa-solid fa-file-arrow-down",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (startImageDownload($event, pictureData.value)))
          }),
          _createVNode(TRButton, {
            class: "min-w-[130px]",
            text: "Artikel",
            "icon-position": 'left',
            icon: "fa-solid fa-newspaper",
            onClick: openArticleWindow
          }),
          _createVNode(TRButton, {
            class: "min-w-[130px]",
            text: "Import",
            "icon-position": 'left',
            icon: "fa-solid fa-file-export",
            onClick: exportImages
          })
        ]),
        (!serverIsMounted.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[13] || (_cache[13] = [
              _createElementVNode("i", { class: "fa-solid fa-triangle-exclamation" }, null, -1),
              _createTextVNode(" Server nicht gemountet ")
            ])))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(showSpinner))
      ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TRButton, {
          icon: "fa-solid fa-magnifying-glass",
          "icon-position": "left",
          text: "Suchen",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (searchWithTerm(searchTerm.value)))
        }),
        _createVNode(TRInput, {
          "focus-after-clear": true,
          class: "bg-trader-dark-gray p-1 rounded",
          type: "gray",
          placeholder: "Suche...",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (searchWithTerm(searchTerm.value)), ["enter"])),
          modelValue: searchTerm.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchTerm).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(TRSelect, {
          class: "bg-trader-dark-gray p-1 rounded flex-grow",
          options: selectOptions,
          modelValue: selectSearchOption.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectSearchOption).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TRButton, {
          selected: searchType.value == 'nonFood',
          text: "NonFood",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (searchForNonFood()))
        }, null, 8, ["selected"]),
        _createVNode(TRButton, {
          selected: searchType.value == 'food',
          text: "Food ",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (searchForFood()))
        }, null, 8, ["selected"]),
        _createVNode(TRContainer, {
          direction: 'row',
          class: "items-center gap-2",
          onClick: toggleCheckbox
        }, {
          default: _withCtx(() => [
            _createElementVNode("input", {
              type: "checkbox",
              ref_key: "myCheckbox",
              ref: myCheckbox,
              onClick: toggleCheckbox
            }, null, 512),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "nicht im Go2Pict", -1))
          ]),
          _: 1
        }),
        _createVNode(TRContainer, {
          direction: 'row',
          class: "items-center gap-2",
          onClick: addToArticleNumberToMainArticle
        }, {
          default: _withCtx(() => [
            _createElementVNode("input", {
              type: "checkbox",
              ref_key: "addToArticleScheckBox",
              ref: addToArticleScheckBox,
              onClick: addToArticleNumberToMainArticle
            }, null, 512),
            _cache[15] || (_cache[15] = _createElementVNode("p", null, "Artikel Nummern aud Dateinamen", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(TRTable, {
          "open-picture": true,
          dataRows: tableData.value,
          header: header,
          "on-selection-change": onSelectionChange
        }, {
          cell: _withCtx(({ row, field, selected }) => [
            (field === 'isInFavorite')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "p-1",
                  onClick: ($event: any) => (editImageFavorite(row))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(row.isInFavorite ? 'fa-solid fa-star  text-yellow-300' : 'fa-regular fa-star')
                  }, null, 2)
                ], 8, _hoisted_9))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "overflow-hidden whitespace-nowrap text-ellipsis",
                  innerHTML: formatCellValue(row, field, selected)
                }, null, 8, _hoisted_10))
          ]),
          _: 1
        }, 8, ["dataRows"]),
        _createVNode(TRTablePager, {
          numberOfData: numberOfPictures.value,
          "on-page-step": onPageStep,
          "data-length": tableData.value.length
        }, null, 8, ["numberOfData", "data-length"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(TRContainer, {
          title: "Bildvorschau",
          scrollable: "",
          class: "h-[300px] w-[300px] gap-2 overflow-hidden flex-shrink-0"
        }, {
          default: _withCtx(() => [
            (!pictureIsMounted.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, "BIld ist nicht gemounted"))
              : _createCommentVNode("", true),
            (picturesData.value.length == 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "flex h-full w-full",
                  onDragstart: _cache[7] || (_cache[7] = ($event: any) => (onDragStart($event,pictureData.value)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(picturesData.value, (picture, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: picture.id
                    }, [
                      (picture?.imgLocNewFilepath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "w-full h-full object-contain",
                            src: picture?.imgLocNewFilepath,
                            alt: ""
                          }, null, 8, _hoisted_13))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true),
            (picturesData.value.length == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(picturesData.value, (picture, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: picture.id
                    }, [
                      (picture?.imgLocNewFilepath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "w-1/2 h-full object-contain",
                            src: picture?.imgLocNewFilepath,
                            alt: "",
                            onDragstart: ($event: any) => (onDragStart($event,picture))
                          }, null, 40, _hoisted_15))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (picturesData.value.length == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(picturesData.value, (picture, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: picture.id
                    }, [
                      (picture?.imgLocNewFilepath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "w-1/3 h-full object-contain",
                            src: picture?.imgLocNewFilepath,
                            alt: "",
                            onDragstart: ($event: any) => (onDragStart($event,picture))
                          }, null, 40, _hoisted_17))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (picturesData.value.length == 4)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "grid grid-cols-2 gap-1 h-full w-full",
                  onDragstart: _cache[8] || (_cache[8] = ($event: any) => (onDragStart($event,pictureData.value)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(picturesData.value, (picture, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: picture.id,
                      class: "flex items-center bg-trader-light-gray justify-center overflow-hidden"
                    }, [
                      (picture?.imgLocNewFilepath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "object-contain max-w-full max-h-full",
                            src: picture?.imgLocNewFilepath,
                            alt: "",
                            onDragstart: ($event: any) => (onDragStart($event, picture))
                          }, null, 40, _hoisted_18))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true),
            (picturesData.value.length == 5 || picturesData.value.length == 6)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 5,
                  class: "grid grid-cols-3 gap-1 h-full w-full",
                  onDragstart: _cache[9] || (_cache[9] = ($event: any) => (onDragStart($event,pictureData.value)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(picturesData.value, (picture, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: picture.id,
                      class: "flex items-center bg-trader-light-gray justify-center overflow-hidden"
                    }, [
                      (picture?.imgLocNewFilepath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "object-contain max-w-full max-h-full",
                            src: picture?.imgLocNewFilepath,
                            alt: "",
                            onDragstart: ($event: any) => (onDragStart($event, picture))
                          }, null, 40, _hoisted_19))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true),
            (picturesData.value.length <= 9 && picturesData.value.length >= 7)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 6,
                  onDragstart: _cache[10] || (_cache[10] = ($event: any) => (onDragStart($event,pictureData.value))),
                  class: "grid grid-cols-3 overflow-auto gap-1 h-full w-full"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(picturesData.value, (picture, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: picture.id,
                      class: "flex items-center bg-trader-light-gray justify-center overflow-hidden"
                    }, [
                      (picture?.imgLocNewFilepath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "object-contain max-w-full max-h-full",
                            src: picture?.imgLocNewFilepath,
                            alt: "",
                            onDragstart: ($event: any) => (onDragStart($event, picture))
                          }, null, 40, _hoisted_20))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true),
            (picturesData.value.length > 9)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 7,
                  class: "grid grid-cols-3 overflow-auto gap-1 h-full w-full",
                  onDragstart: _cache[11] || (_cache[11] = ($event: any) => (onDragStart($event,pictureData.value)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(picturesData.value, (picture, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: picture.id,
                      class: "flex items-center bg-trader-light-gray justify-center"
                    }, [
                      (picture?.imgLocNewFilepath)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "object-contain max-w-full max-h-full",
                            src: picture?.imgLocNewFilepath,
                            alt: "",
                            onDragstart: ($event: any) => (onDragStart($event, picture))
                          }, null, 40, _hoisted_21))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(TRContainer, {
          title: "Bildinformationen",
          scrollable: true,
          class: "flex-grow"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "w-1/2 p-1" }, "Artikelnummer", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleNumbers.value, (articleNumber) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["flex justify-center items-center text-center hover:bg-trader-blue cursor-pointer hover:text-white", { 'bg-trader-blue': selectedArticleNumber.value == articleNumber }]),
                        onClick: ($event: any) => (openNewArticleWindow(articleNumber)),
                        key: articleNumber
                      }, _toDisplayString(articleNumber), 11, _hoisted_26))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "w-1/2" }, "Dateigröße", -1)),
                (pictureData.value.imgLocMainFileSize)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(formatBytes(pictureData.value.imgLocMainFileSize)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "w-1/2" }, "Auflösung", -1)),
                _createElementVNode("span", null, _toDisplayString(pictureData.value.imgLocImagDpiOrg), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "w-1/2" }, "Pixelgröße", -1)),
                (pictureData.value.imgLocImagWithOrg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(pictureData.value.imgLocImagWithOrg) + " * " + _toDisplayString(pictureData.value.imgLocImagHightOrg), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "w-1/2" }, "Änderungsdatum", -1)),
                _createElementVNode("span", null, _toDisplayString(pictureData.value?.imgLocFileModDate), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "w-1/2" }, "OriginalPfad", -1)),
                _createElementVNode("span", _hoisted_34, _toDisplayString(pictureData.value?.imgLocOrgFilepath), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "w-1/2" }, "Originalname", -1)),
                _createElementVNode("span", _hoisted_36, _toDisplayString(pictureData.value?.imgLocOrgFilename), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "w-1/2" }, "Neuer Pfad", -1)),
                _createElementVNode("span", _hoisted_38, _toDisplayString(pictureData.value?.imgLocNewFilepath), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "w-1/2" }, "Neuer Name", -1)),
                _createElementVNode("span", _hoisted_40, _toDisplayString(pictureData.value?.imgLocNewFilename), 1)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(TRContainer, {
        class: "flex flex-col w-[200px] flex-shrink-0",
        title: "Importklasse"
      }, {
        default: _withCtx(() => [
          _createVNode(TRButton, {
            padding: 1,
            onClick: updateImageClass,
            text: "speichern"
          }),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(TRListe, {
              "data-list": importClass.value,
              "on-selection-change": getImgLocGo2pictClass,
              "selected-id": pictureData.value.IMGLocGo2pictClass
            }, null, 8, ["data-list", "selected-id"])
          ])
        ]),
        _: 1
      }),
      _createVNode(TRContainer, {
        class: "flex-grow flex-shrink-0",
        title: "EK-Bereiche",
        direction: "column"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(TRButton, {
              padding: 1,
              onClick: resetSearch,
              icon: "fa-solid fa-xmark",
              "icon-position": "left",
              text: "Alle anzeigen"
            }),
            _createVNode(TRButton, {
              padding: 1,
              icon: "fa-solid fa-magnifying-glass",
              "icon-position": "left",
              text: "Suchen"
            }),
            _createVNode(TRInput, {
              class: "bg-trader-dark-gray p-1 rounded",
              type: "gray",
              placeholder: "Suche...",
              modelValue: searchPurchaser.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((searchPurchaser).value = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(TRButton, {
              padding: 1,
              onClick: updatePurchaser,
              text: "speichern"
            })
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(TRListe, {
              "data-list": purchaserCell.value,
              "on-selection-change": getPurchaserId,
              "selected-id": pictureData.value.purchaserID,
              "search-input": searchPurchaser.value
            }, null, 8, ["data-list", "selected-id", "search-input"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})